// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ec567b48].el-table .cell{padding-left:20px !important}.mt5[data-v-ec567b48]{margin-top:5px}[data-v-ec567b48] .el-card__body{padding:30px 24px !important}[data-v-ec567b48] .el-form-item{margin-bottom:0px !important}[data-v-ec567b48] .el-card__body{padding:20px 24px !important}", ""]);
// Exports
module.exports = exports;
